import { Fieldset, Radio } from "@digdir/designsystemet-react";
import type { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { TranslatedValidationMessage } from "@/components";
import {
  type bestillerSelskapFormValues,
  næringsdrivendeSchema,
  Tekstfelt,
  translationPrefixSelskapForm,
} from "../bestillinger/forms";

type NæringsbyggFieldsProps = {
  form: UseFormReturn<bestillerSelskapFormValues>;
  isNæringsbyggMedBoliger: boolean;
  isNæringsdrivende: boolean;
  readOnly: boolean;
};

export const NæringsbyggFields = ({
  form,
  isNæringsbyggMedBoliger,
  isNæringsdrivende,
  readOnly,
}: NæringsbyggFieldsProps) => {
  const { t } = useTranslation();

  return (
    <section>
      {isNæringsbyggMedBoliger === false && (
        // Antall boenheter skal alltid være 1 for næringsbygg med boliger
        <Tekstfelt
          feltKey="antallBoenheter"
          type="number"
          min="1"
          inputMode="numeric"
          readOnly={readOnly}
          labelTranslationPrefix={translationPrefixSelskapForm}
        />
      )}
      {isNæringsbyggMedBoliger === false && (
        // Næringsbygg med boliger er alltid næringsdrivende
        <Fieldset>
          <Fieldset.Legend>
            {t(`${translationPrefixSelskapForm}.felt`, {
              context: "næringsdrivende",
            })}
          </Fieldset.Legend>
          <div className="flex flex-wrap gap-4">
            {Object.values(næringsdrivendeSchema.enum).map((jaNei) => (
              <Radio
                key={jaNei}
                label={t("enums.jaNei", { context: jaNei })}
                value={jaNei}
                {...form.register("næringsdrivende")}
                name="næringsdrivende"
              />
            ))}
          </div>
          <TranslatedValidationMessage
            error={form.formState.errors.næringsdrivende}
          />
        </Fieldset>
      )}

      {isNæringsdrivende && (
        <Tekstfelt
          className="[&_*_input]:w-[8ch] [&_*_input]:flex-none"
          feltKey="næringsarealProsent"
          type="text"
          inputMode="decimal"
          pattern="^\\d+(?:[.,]\\d{1,2})?$"
          readOnly={readOnly}
          labelTranslationPrefix={translationPrefixSelskapForm}
          suffix="%"
          hjelpeTekst={true}
        />
      )}
    </section>
  );
};
